import { ClientPool } from "./types";

const defaultState = {
    haveUpdates: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ClientPool.HAVE_UPDATES:
            return {
                ...state,
                haveUpdates: action.haveUpdates,
            };

        default:
            return state;
    }
};
